import JSBI from 'jsbi';

export const ZERO = JSBI.BigInt(0);

export function lessThanZero(a: JSBI) {
  return JSBI.lessThan(a, ZERO);
}

export function lessThanEZero(a: JSBI) {
  return JSBI.lessThanOrEqual(a, ZERO);
}

export function add(a: JSBI, b: JSBI) {
  return JSBI.add(a, b);
}

export function subtract(a: JSBI, b: JSBI) {
  return JSBI.subtract(a, b);
}
